import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Box, Button, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";

function SocialActivityList() {
  let location = useLocation();
  const [pageListContent, setPageListContent] = useState([]);
  useEffect(() => {
    axios
      .post("/api/website/getPageList", {
        menuPath: location.pathname.replace("/", ""),
      })
      .then((response) => {
        console.log(response.data.data);
        const pageData = response.data.data.pageDataList;
        setPageListContent(pageData);
      })
      .catch((error) => {
        console.error("Error fetching article content:", error);
      });

    return () => {};
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <section className="h-[250px] m-auto pt-[90px] page-title">
          <div className="text-center mb-[44px]">
            <h2 className="text-[#3D3D3D] font-semibold text-5xl mb-[15px]">社團活動</h2>
            <h3 className="text-[#696969] font-normal text-xl" style={{ color: "#ff6b2b" }}>
              Social Activity
            </h3>
          </div>
        </section>
        <section className="max-w-[1300px] m-auto pt-[10px] mb-16">
          {pageListContent.length !== 0 &&
            pageListContent.map((item, index) => (
              <div key={"list" + index}>
                <Box className="my-[10px]" display="flex" width="100%">
                  <Box className="pl-[50px] pr-[30px] pt-[20px] pb-[20px]" width="50%">
                    <img src={item.image} alt="" className="border-8 border-white shadow-2xl" />
                  </Box>
                  <Box className="pl-[30px] pr-[50px] pt-[30px] pb-[30px]" width="50%">
                    <p
                      className="pb-[25px]"
                      style={{
                        fontSize: "30px",
                        color: "#A93230",
                        fontWeight: 400,
                      }}
                    >
                      {item.title}
                    </p>
                    <Button
                      sx={{
                        fontSize: "20px",
                        padding: "13px 35px",
                        backgroundColor: "#FFCC06",
                        color: "black",
                        fontWeight: 400,
                        "&:hover": { backgroundColor: "darkorange" },
                      }}
                      component={Link}
                      to={"/" + item.path + "?id=" + item.id}
                    >
                      查看更多
                    </Button>
                  </Box>
                </Box>
                <Divider />
              </div>
            ))}
        </section>
      </main>
      <Footer />
    </>
  );
}

export default SocialActivityList;
